@if (propertyViewModel?.securityAccess == null) {
  <nts-base-date-text-box
    #baseDateTextBox
    (onDateValueChange)="onDateValueChange($event)"
    (onDateFocus)="onDateFocus($event)"
    (onDateSelect)="onDateSelect($event)"
    (onCalendarShow)="onCalendarShow($event)"
    (onDateBlur)="onDateBlur($event)"
    (onFinishEditing)="onFinishEditing.emit($event)"
    [valueDate]="valueDate"
    [defaultBorderColor]="propertyViewModel.defaultColor"
    [activeBorderColor]="propertyViewModel.activeColor"
    [hoverBorderColor]="propertyViewModel.hoverColor"
    [appendTo]="appendTo"
    [listenClickOutside]="listenClickOutside"
    [isRequired]="propertyViewModel.isRequired"
    [isNullable]="isNullable"
    [showTime]="propertyViewModel.showTime"
    [showButtonBar]="showButtonBar"
    [initialChar]="initialChar"
    [isDisabled]="isDisabled || !(propertyViewModel.isEnabled$ | async) || propertyViewModel?.securityAccess != null"
    [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
    [showErrorTooltip]="showErrorTooltip"
    [showErrorBorder]="showErrorBorder"
    (viewReady)="onBaseViewReady()"
    [maskSettings]="maskSettings" [title]="propertyViewModel.formattedValue$ | async"
  [customCommandList]="customCommandList"></nts-base-date-text-box>
} @else {
  <nts-base-security-text-box #baseSecurityTextBox [accessMode]="propertyViewModel.securityAccess"
    (viewReady)="onBaseViewReady()"
  [value]="initialValue != null ? initialValue : propertyViewModel.formattedValue$ | async"></nts-base-security-text-box>
}


